.Frame {
  top: 0em;
  left: 0em;
  right: 0em;
  bottom: 0em;
  width: 16em;
  height: 9em;
  margin: auto;
  position: absolute;
  color: #f0ead6;
  font-family: var(--base-font);
  background-color: #29202e;
  overflow: hidden;
}
